import { useState } from "react";
import { Box, Typography, Alert } from "@mui/material";
import { formSurfaceSx } from "constants/pageSurfaces";
import Breadcrumbs from "components/common/Breadcrumbs";
import { useNavigate } from "react-router-dom";
import { api } from "services/api.service";
import LocationForm, { emptyLocationForm, LocationFormValues } from "./LocationForm";

export default function LocationNew() {
  const navigate = useNavigate();
  const [values, setValues] = useState<LocationFormValues>(emptyLocationForm());
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    api
      .post("/locations", { location: values })
      .then(() => navigate("/locations"))
      .catch((err) => {
        const msg =
          err?.response?.data?.errors?.join?.(", ") ||
          err?.response?.data?.errors ||
          "Could not create location";
        setError(String(msg));
      });
  };

  return (
    <div>
      <Box>
        <Breadcrumbs
          data={[
            { label: 'Dashboard', to: '/dashboard' },
            { label: 'Locations', to: '/locations' },
            { label: 'New' },
          ]}
        />
      </Box>
      <Box sx={formSurfaceSx}>
        <Typography variant='h4' mb={2} fontWeight='bold'>
          New location
        </Typography>
        {error ? (
          <Alert severity='error' sx={{ mb: 2 }}>
            {error}
          </Alert>
        ) : null}
        <LocationForm
          values={values}
          onChange={setValues}
          onSubmit={handleSubmit}
          submitLabel='Create'
          cancelTo='/locations'
        />
      </Box>
    </div>
  );
}
